"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeReactionCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const boolean_transform_1 = require("../../constants/boolean.transform");
const enums_1 = require("../../enums");
class BehaviorCodeReactionCreateDto extends mappable_base_1.MappableBase {
    constructor(behaviorCodeReactionOptions) {
        super();
        if (!behaviorCodeReactionOptions)
            return;
        Object.assign(this, behaviorCodeReactionOptions);
    }
    getFields() {
        return [
            'triggerCount',
            'printCopies',
            'points',
            'reactionMultiplier',
            'behaviorCodeId',
            'reactionId',
            'schoolId',
            'active',
            'reactionType',
        ];
    }
    triggerCount;
    printCopies;
    points;
    reactionMultiplier;
    behaviorCodeId;
    reactionId;
    schoolId;
    active;
    reactionType;
}
exports.BehaviorCodeReactionCreateDto = BehaviorCodeReactionCreateDto;
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)(o => o.reactionType !== enums_1.ReactionTypeEnum.SELECT_MENU),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "triggerCount", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "printCopies", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "points", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "reactionMultiplier", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "behaviorCodeId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "reactionId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeReactionCreateDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorCodeReactionCreateDto.prototype, "active", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.ReactionTypeEnum),
    __metadata("design:type", String)
], BehaviorCodeReactionCreateDto.prototype, "reactionType", void 0);
